import { Typography } from "@initia-digital/component-library"
import { Box, Link } from "@mui/material"
import { pink } from "@mui/material/colors"
import { LocalHospital as LocalHospitalIcon } from '@mui/icons-material'


export const EmergencyDirectiveBanner = () => {
    return (
        <Box
            display="flex" 
            flexDirection="column" 
            alignItems="center"
            width="100%"
            pb="10px"
            gap="4px"
        >
            <Typography
                fontSize="1rem"
                color={pink[500]}
                fontWeight={700}
            >
                In an emergency, get to safety and dial 111
            </Typography>
            <Link
                href="https://www.google.co.nz/maps/search/accident+and+emergency+near+me"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    fontSize: '0.9rem',
                    fontWeight: 400,
                    color: pink[500],
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }}
            >
                <LocalHospitalIcon sx={{ fontSize: '0.9rem' }} />
                Nearest accident & emergency centre
            </Link>
        </Box>
    )
}